import { EJoinGameQuality, EJoinGamePlatform } from '../types/socket';
import { mobileAndTabletCheck } from '../utils';

import type { IJoinEventInputParams } from '../types/socket'

export function generateWsJoinDefaultParams (inputParams: IJoinEventInputParams) {
  const { deviceId, ip: client_ip, gameInfo: cloudgame_cfg, ...other } = inputParams
  const { token, uid } = other;
  const authparams = JSON.stringify({ deviceId, token, uid });

  const type = mobileAndTabletCheck() ? EJoinGamePlatform.MOBILE : EJoinGamePlatform.PC;

  return {
    authparams,
    quality: EJoinGameQuality.HD,
    sys_locale: 'en-US',
    type,
    // client_ip,
    user_agent: window.navigator.userAgent,
    cloudgame_cfg,
    ...other,
  }
}


